"use client";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import {
	AddAddressInterface,
	EditAddressProps,
	LocationDetailsInterface,
} from "@/interface/account";
import { AppDispatch, AppState } from "@/store/configureStore";
import toast from "react-hot-toast";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { EDIT_ADDRESS_API } from "@/constants";
import { listOfStates } from "@/utils/selectField";
import { updateAddress } from "@/store/slices/userSlice";
import { useGlobalContext } from "@/contexts/AppContext";

const useEditAddress = ({ onClose, address }: EditAddressProps) => {
	const { theme, setAddresses, addresses } = useGlobalContext();
	const user = useSelector((state: AppState) => state.user);
	const dispatch = useDispatch<AppDispatch>();

	const editAddressSchema = yup.object({
		name: yup.string(),
		address: yup.string(),
		phone_number: yup.string(),
		landmark: yup.string(),
	});

	const {
		register,
		watch,
		handleSubmit,
		reset,
		resetField,
		setValue,
		clearErrors,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(editAddressSchema),
		// defaultValues: {
		// 	country: address?.country,
		// 	state: address?.state,
		// 	city: address?.city,
		// 	street: address?.street,
		// 	name: address?.name,
		// 	email: address?.email,
		// 	phone_number: address?.phone_number,
		// },
	});

	const [selectState, setSelectState] = useState<string>("");

	const handleEditAddress = async (
		data: AddAddressInterface,
		locationDetails: LocationDetailsInterface,
		id: string
	) => {
		// console.log(address?.id);
		// console.log(locationDetails);

		try {
			const response = await axios.put(
				`${EDIT_ADDRESS_API}/${id}`,
				{
					street: locationDetails.street,
					city: locationDetails.city,
					state: locationDetails.state,
					name: data.name,
					phoneNumber: data.phone_number,
					landmark: data.landmark,
				},
				{
					headers: {
						Authorization: `Bearer ${user?.token}`,
					},
				}
			);

			dispatch(
				updateAddress({
					addresses: response?.data?.user?.addresses,
				})
			);
			onClose();
			reset();
			setAddresses(addresses);
			toast.remove();
			toast.success(`${response.data.msg}`);
		} catch (error: string | any) {
			// console.log("API Error", error);
		}
	};

	return {
		register,
		handleSubmit,
		errors,
		watch,
		handleEditAddress,
		listOfStates,
	};
};
export default useEditAddress;
